import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";
import { CardBase } from "~/components/timeLine/cardBase.jsx";
import { ChecklistEditor } from "../../dayTemplate/checklistTemplateEditor.jsx";
import { HelpLine } from "~/components/help/helpLine.jsx";

export const CardChecklists = ({ data, saveAndNext, prev }) => {
  const [checklistStart, setChecklistStart] = useState([]);
  const [checklistEnd, setChecklistEnd] = useState([]);

  useEffect(() => {
    setChecklistStart(data.checklist_start_day || []);
    setChecklistEnd(data.checklist_end_day || []);
  }, [data.checklist_start_day, data.checklist_end_day]);

  const handleSave = () => {
    saveAndNext({ checklist_start_day: checklistStart, checklist_end_day: checklistEnd });
  };

  return (
    <CardBase prev={prev} next={handleSave}>
      
      <ChecklistEditor
        checklistStart={checklistStart}
        setChecklistStart={setChecklistStart}
        checklistEnd={checklistEnd}
        setChecklistEnd={setChecklistEnd}
      />

    </CardBase>
  );
};
